<template>
  <div
    class="backgroudColor"
    @mouseenter="btnMouseEnter()"
    @mouseleave="btnMouseLeave()"
  >
    <el-row class="content">
      <el-col :span="15" style="margin-top: 20px">
        <el-row style="margin-left: 28px">
          <el-col :span="18" class="fonttextleft" style="margin-top: 10px">
            <span class="companyName"
              >{{ item.cpPositionName }}[{{ item.cpProvinceLabel }}•{{
                item.cpCityLabel
              }}•{{ item.cpCountyLabel }}]</span
            >
            <span class="descFont" style="margin-left: 10px"
              >发布于{{ item.createTime }}</span
            >
          </el-col>
          <el-col :span="6" class="fonttextleft" style="margin-top: 10px">
            <span class="companyName">{{ item.comAbbreviation }}</span>
          </el-col>
        </el-row>

        <el-row style="padding-left: 28px">
          <el-col :span="12" class="fonttextleft" style="margin-top: 5px">
            <span class="money"
              >{{ item.cpMinSalary.replace('>','') }}-{{ item.cpMaxSalary.replace('>','') }}</span
            >
            <span class="compositiondesc">经验{{ item.cpJobYearsLabel }}</span>
            <span class="compositiondesc">{{ item.cpEducationLabel }}学历</span>
            <span class="compositiondesc">{{
              item.cpFormsOfEmploymentLabel
            }}</span>
          </el-col>

          <el-col :span="4" class="fonttextleft persionMsg" style>
            <el-button
              icon="el-icon-chat-dot-round"
              :class="!isShow ? 'btnActive' : 'btnMsg'"
            @click="openIM(item)">
              <span v-if="isShow">{{ item.cpHr }} | HR</span>
              <span v-if="!isShow">立即沟通</span>
            </el-button>
          </el-col>

          <el-col
            :span="4"
            class="fonttextleft"
            style="margin-top: 5px; margin-left: 38px"
          >
            <span class="compositiondesc" style="padding-left: 20px">{{
              item.comIndustry == null ? "其他" : item.comIndustry
            }}</span>
          </el-col>
        </el-row>
      </el-col>

      <el-col :span="8">
        <el-row style="height: 63px; line-height: 63px; margin-top: 35px">
          <el-col :span="8">
            <img
              :src="
                item.comLogo != null
                  ? viewPath + item.comLogo
                  : '../assets/pcImage/company_default_logo.png'
              "
              class="logo"
            />
          </el-col>

          <el-col :span="8" class="buttonBorder" style>
            <span class style="margin-right: 5px">
              <img
                src="../assets/pcImage/aixin.png"
                style="line-height: 44px; vertical-align: middle"
              />
            </span>
            <span style="color: #737373; cursor: pointer">感兴趣</span>
          </el-col>
          <el-col
            :span="8"
            class="buttonBorder"
            style="margin-left: 15px; background: #f82b18"
          >
            <span style="color: white; cursor: pointer">立即沟通</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col>
        <el-row
          style="
            background: rgba(246, 246, 248, 1);
            height: 40;
            line-height: 40px;
            margin-top: 15px;
            padding-left: 28px;
          "
        >
          <el-col :span="11" style="text-align: left">
            <span
              class="fulimsg"
              v-for="val in item.cpDamagedArea.split(',')"
              >{{ val }}</span
            >
          </el-col>

          <el-col :span="12" class="wuxianyijin">{{
            item.comWelfareNames
          }}</el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { createIM } from "@/comm/api";

export default {
  name: "UsersResume",
  components: {},
  props: ["item"],
  data() {
    return {
      isShow: true,
      viewPath: (window._CONFIG["domianURL"] += "/sys/common/view/"),
    };
  },
  methods: {
    btnMouseEnter() {
      this.isShow = false;
    },
    btnMouseLeave() {
      this.isShow = true;
    },
    openIM(item) {
      createIM(item).then((res) => {
        this.$store.commit("SET_CURRENTIMITEM", item);
        this.$router.push({
          name: `pcDisabledChat`,
          params: {
            item: item,
          },
        });
      });
    }
  },
};
</script>


<style lang="stylus" scoped>
.fulimsg {
  // width: 60px;
  height: 20px;
  opacity: 0.6;
  border: 1px solid #a1a1a1;
  font-size: 12px;
  margin-top: 8px;
  margin-right: 8px;
  line-height: 20px;
  border-radius: 3px;
  padding: 1px 2px;

  span {
    width: 48px;
    height: 12px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    vertical-align: top;
  }
}

.money {
  font-size: 16px;
  font-weight: 400;
  color: rgba(242, 20, 47, 1);
  line-height: 24px;
  margin-right: 20px;
}

.hrName {
  padding: 0 5px;
  height: 12px;
  line-height: 12px;
  color: #a1a1a1;
  // border-right: 2px solid #a1a1a1;
}

.img {
  height: 12px;
  width: 11px;
  padding-left: 10px;
  margin: 0 2px -1px 0;
}

.logo {
  width: 50px;
  height: 50px;
  margin-left: -80px;
  border-radius: 50px;
}

.buttonBorder {
  width: 104px;
  height: 44px;
  border-radius: 6px;
  border: 1px solid #f82b18;
  line-height: 44px;
}

.compositiondesc {
  width: 91px;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #737373;
  line-height: 21px;
  padding: 0 10px 0 0;
}

.content {
  // text-align: right;
  width: 1144px;
  margin: 0 auto;
}

.btnMsg {
  // width: 90px;
  height: 24px;
  padding: 0px 12px 0px 5px;
  line-height: 0px;
  border-radius: 9px;
  border: 1px solid #c2c2c2;
  font-size: 12px;
  font-weight: 400;
  color: #9E9E9E;
}

.btnActive {
  width: 90px;
  height: 24px;
  padding: 0px 12px 0px 5px;
  line-height: 0px;
  border-radius: 9px;
  // border: 1px solid #c2c2c2;
  border: none;
  font-size: 12px;
  font-weight: 400;
  background: #f82b18;
  border-radius: 9px;
  color: white;
}

.backgroudColor {
  width: 1144px;
  height: 130px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 0 auto;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;

  .descFont {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #bcbcbc;
    line-height: 21px;
  }

  .persionMsg {
    // width: 90px;
    height: 24px;
    border-radius: 12px;
    // opacity: 0.2;
    color: #a1a1a1;
    // border: 1px solid #f2f2f2;
    margin-top: 5px;
    font-size: 12px;
    line-height: 24px;
  }

  .wuxianyijin {
    font-size: 14px;
    font-weight: 400;
    color: #737373;
    line-height: 41px;
    text-align: left;
    padding-left: 0%;
  }

  .companyName {
    width: 168px;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    color: #f82b18;
    line-height: 24px;
  }

  .fonttextleft {
    text-align: left;
  }
}
</style>
